import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useLocalStorageStoreFilterActivated = () => {
  const location = useLocation();
  const [isStoreFilterActivated, setIsStoreFilterActivated] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(location.search);
      const storeFilterActivated = params.get('storeFilterActivated');

      if (storeFilterActivated === 'true' || storeFilterActivated === 'false') {
        // Update localStorage with the value from the URL
        localStorage.setItem('storeFilterActivated', storeFilterActivated);
        // Update the state
        setIsStoreFilterActivated(storeFilterActivated === 'true');
      } else {
        setIsStoreFilterActivated(localStorage.getItem('storeFilterActivated'));
      }
    }
  }, [location.search]); // Re-run when the URL changes

  return [isStoreFilterActivated, setIsStoreFilterActivated];
};

export default useLocalStorageStoreFilterActivated;
